import Tag, { TTagColor } from '@/shared/Tags/Tag'
import css from './statisticCard.module.css'
import cn from '@/utils/cn'
import { useMemo } from 'react'

type TStatisticCard = 'NORMAL' | 'WARNING' | 'ERROR' | 'IN_MAINTENANCE'

interface IProps {
  text: number
  type: TStatisticCard
}

const StatisticCard = (props: IProps) => {
  const tagParams = useMemo(() => {
    switch (props.type) {
      case 'NORMAL':
        return { text: 'В работе', tagColor: 'green' }
      case 'IN_MAINTENANCE':
        return { text: 'На обслуживании', tagColor: 'blue' }
      case 'WARNING':
        return { text: 'Предупреждения', tagColor: 'orange' }
      default:
        return { text: 'Авария', tagColor: 'red' }
    }
  }, [])

  return (
    <div className={css.wrapper} data-type={props.type}>
      <Tag color={tagParams.tagColor as TTagColor}>
        <p className="text-caption" style={{ color: 'inherit' }}>
          {tagParams.text}
        </p>
      </Tag>
      <span className={cn('text-heading-1')}>{props.text}</span>
    </div>
  )
}

export default StatisticCard
